import React, { useRef } from "react";
import livePriceInfo from "../../assets/images/svg/livePriceInfo.svg";
//import ExtractButton from "../ExtractButton/ExtractButton";
import UserStore from "../../store/UserStore";
import SearchButton2 from "../SearchButton2/SearchButton2";
import { memo } from "react";
import { getSubAssetClasses } from "../../utils/functions";
import { useParams } from "react-router";
//import PopupMenuData from "../PopupMenuData/PopupMenuData";
import ExportReportList from "../AccessibleDropdown/ExportReportList";
import { exportDataMenu } from "../../utils/constants";
import { useState } from "react";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";

const DirectEquityFilter = ({
  search,
  setSearch,
  title2,
  exportExcel,
  exportPdf,
  restrictHover,
  onClick = () => {},
  toggle = false,
}) => {
  //const [open, setOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const searchButtonRef = useRef(null);
  const itemRefs = useRef([]);

  const { vehicleId } = useParams();

  // const ExtractDataContent = () => {
  //   return (
  //     <div className="extract_data_container downloadPdf">
  //       <p className="export_data_text">Export Data</p>
  //       {/* <ul className="listitem_container">
  //         <li onClick={exportExcel}>
  //           <div className="listitem_icon excel"></div> Export to Excel
  //         </li>
  //         <li onClick={exportPdf}>
  //           <div className="listitem_icon pdf"></div> Export to PDF
  //         </li>
  //       </ul> */}
  //       <div className="listitem_container">
  //         <button
  //           className="list-data"
  //           role="menuitem"
  //           onClick={() => {
  //             exportExcel();
  //             setOpen(false);
  //           }}
  //         >
  //           <div className="listitem_icon excel"></div>
  //           <div>Export to Excel</div>
  //         </button>
  //         <button
  //           className="list-data"
  //           role="menuitem"
  //           onClick={async () => {
  //             if (isDownloading) return; // guard against double-click while already running
  //             setIsDownloading(true);
  //             try {
  //               await exportPdf();
  //             } finally {
  //               setIsDownloading(false);
  //               setOpen(false);
  //             }
  //           }}
  //         >
  //           <div className="listitem_icon pdf"></div> <div>Export to PDF</div>
  //         </button>
  //       </div>

  //       {isDownloading && (
  //         <div className="popup_downloader">
  //           <img src={loaderGIF} alt="img" />
  //         </div>
  //       )}
  //     </div>
  //   );
  // };
  return (
    <div className="direct_equity_filter_outside">
      <h2>
        {" "}
        Instruments in{" "}
        <span>
          {
            title2 || getSubAssetClasses(vehicleId)
            //UserStore.subAssetClassName
          }
        </span>
      </h2>
      {title2 &&
        title2 === "Direct Equity/Stocks" &&
        UserStore.isInfinity === "0" && (
          <>
            <h2>{"Show Live Price"}</h2>
            <div className="img_wrapper">
              <img className="money_info" src={livePriceInfo} alt="livePrice" />
              <div className="tool">
                Enabling this will change Current Value, Unrealised Gain and CMP
              </div>
            </div>

            <div
              className={
                // UserStore.toggleLive
                toggle ? "filter_toggle_btn" : "filter_toggle_btn_close"
              }
            >
              <input
                onChange={(e) => {
                  onClick(e);
                }}
                type="checkbox"
                id="toggle_btn_1"
              />
              <label htmlFor="toggle_btn_1"></label>
            </div>
          </>
        )}
      <div ref={searchButtonRef} className="filter_search_btn">
        <SearchButton2
          type={"search"}
          search={search}
          setSearch={(data, isClosed) => setSearch(data, isClosed)}
          classes={"search_btn_out3"}
          closeBtn={"big"}
          from={"portfolio"}
          ariaLabel={"Search By Instrument Name"}
        />
      </div>
      {/* <PopupMenu
        actionType="hover"
        MenuContent={ExtractDataContent}
        restrictHover={restrictHover}
      >
        <ExtractButton />
      </PopupMenu> */}
      {/* {false && (
        <PopupMenuData
          ariaControls={"export-menu"}
          ariaId={"export-btn"}
          ariaHasPopUp="menu"
          open={open}
          setOpen={setOpen}
          buttonElement={<ExtractButton ariaHidden={true} tabIndex={-1} />}
          popupClassName={{ open: "clicked-hover", close: "" }}
        >
          <ExtractDataContent />
        </PopupMenuData>
      )} */}

      <ExportReportList
        exportExcel={exportExcel}
        exportPdf={async () => {
          if (isDownloading) return; // guard against double-click while already running
          setIsDownloading(true);
          try {
            await exportPdf();
          } finally {
            setIsDownloading(false);
          //setOpen(false);
          }
        }}
        buttonProps={{ buttonType: "normalExport", title: "Extract Data" }}
        popupClassName={{
          open: "clicked-hover",
          close: "",
          wrapperClass: "popup_menu_container",
          containerClass: "downloadPdf",
        }}
        restrictHover={true}
        itemRefs={itemRefs}
        menuItems={exportDataMenu}
        accessibilityValues={{
          buttonId: "export-dropdown",
          ariaHaspopup: "menu",
          ariaControls: "extract-menu",
          ariaLabel: "Extract Data",
        }}
      >
        <>
          {isDownloading && (
            <div className="popup_downloader">
              <img src={loaderGIF} alt="img" />
            </div>
          )}
        </>
      </ExportReportList>
    </div>
  );
};

export default memo(DirectEquityFilter);
